// src/components/context/ProviderWrapper.tsx

import { ReactNode } from 'react'

import {
  AlertsDataProvider,
  AppConfigProvider,
  AppVersionProvider,
  ContractDataProvider,
  ConsumptionDataProvider,
  DashboardDataProvider,
  DatapointDataProvider,
  FolderDataProvider,
  NewsDataProvider,
  NewsTypesDataProvider,
  NotificationDataProvider,
  OperatorDataProvider,
  PanelDataProvider,
  PayloadDataProvider,
  PriceDataProvider,
  SensorDataProvider,
  FactorDataProvider,
  UserDataProvider,
  VirtualSensorDataProvider,
  BenchmarkDataProvider,
} from '../../hooks'

import { PreloaderProvider } from './preloader'

type Props = {
  children: ReactNode
}

export const ProviderWrapper = ({ children }: Props) => (
  <PreloaderProvider>
    <OperatorDataProvider>
      <AlertsDataProvider>
        <AppConfigProvider>
          <AppVersionProvider>
            <ContractDataProvider>
              <DashboardDataProvider>
                <ConsumptionDataProvider>
                  <PanelDataProvider>
                    <DatapointDataProvider>
                      <FolderDataProvider>
                        <NewsDataProvider>
                          <NewsTypesDataProvider>
                            <NotificationDataProvider>
                              <PayloadDataProvider>
                                <SensorDataProvider>
                                  <FactorDataProvider>
                                    <PriceDataProvider>
                                      <UserDataProvider>
                                        <VirtualSensorDataProvider>
                                          <BenchmarkDataProvider>
                                            {children}
                                          </BenchmarkDataProvider>
                                        </VirtualSensorDataProvider>
                                      </UserDataProvider>
                                    </PriceDataProvider>
                                  </FactorDataProvider>
                                </SensorDataProvider>
                              </PayloadDataProvider>
                            </NotificationDataProvider>
                          </NewsTypesDataProvider>
                        </NewsDataProvider>
                      </FolderDataProvider>
                    </DatapointDataProvider>
                  </PanelDataProvider>
                </ConsumptionDataProvider>
              </DashboardDataProvider>
            </ContractDataProvider>
          </AppVersionProvider>
        </AppConfigProvider>
      </AlertsDataProvider>
    </OperatorDataProvider>
  </PreloaderProvider>
)
